<template>
  <!-- 实时识别 -->
  <div class="realTime_page">
    <div class="from_box">
      <div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入图片链接（多个链接请使用“,”号隔开）"
          v-model="imgs"
          @change="confirm"
        />
        <el-button
          class="btn"
          :disabled="loading"
          :loading="loading"
          @click="confirm"
          >确定</el-button
        >
      </div>
    </div>
    <div class="content" v-load="loading">
      <h3 v-if="list.length">识别结果：(共{{ list.length }}条)</h3>
      <ul class="result" v-if="list.length">
        <li class="result_item" v-for="(_item, i) in list" :key="i">
          <el-image
            class="img"
            :src="_item.url"
            :preview-src-list="[_item.url]"
            fit="cover"
          />
          <div class="result_info">
            <ul>
              <li>
                <span>id：</span>
                <p>{{ _item.id }}</p>
              </li>
              <li>
                <span>urlId：</span>
                <p>{{ _item.urlId }}</p>
              </li>
              <li>
                <span>batchId：</span>
                <p>{{ _item.batchId }}</p>
              </li>
              <li>
                <span>来源：</span>
                <p>{{ _item.source }}</p>
              </li>
              <li>
                <span>状态：</span>
                <p :style="'color:' + status[_item.status].color">
                  {{ status[_item.status].status }}
                </p>
              </li>
              <li>
                <span>耗时：</span>
                <p>{{ _item.userTime }}</p>
              </li>
            </ul>
            <div class="result_content">
              <span>图片识别结果：</span>
              <p>{{ _item.text }}</p>
            </div>
          </div>
        </li>
      </ul>
      <p class="null_data" v-else>请在输入框输入图片链接</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      imgs: "",
      list: [],
      status: {
        0: { color: "#F56C6C", status: "处理异常接口" },
        1: { color: "#409EFF", status: "新任务" },
        2: { color: "#909399", status: "队列中" },
        3: { color: "#E6A23C", status: "识别中" },
        4: { color: "#F56C6C", status: "识别错误" },
        5: { color: "#67C23A", status: "识别完成" }
      }
    };
  },
  methods: {
    confirm() {
      if (!this.imgs) {
        this.$hint("请输入图片链接", "err");
        return;
      }
      let urls = this.imgs.replace(/\s*/g, "");
      this.loading = true;
      this.$http({
        url: this.$api.addOnline,
        data: urls.split(","),
        baseUrl: true
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.list = res.data;
          } else {
            this.$hint(res.message, "err");
          }
        })
        .catch(err => {
          this.loading = false;
          this.$hint("操作失败!", "err");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.realTime_page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .from_box {
    padding: 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    > div {
      position: relative;
      &:hover {
        .btn {
          display: block;
        }
      }
      .btn {
        width: 50px;
        height: 25px;
        font-size: 12px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 3px;
        right: 10px;
        display: none;
      }
    }
  }
  .content {
    height: 0;
    flex: 1;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    > h3 {
      color: rgb(84, 92, 100);
      margin-bottom: 10px;
    }
    .result {
      height: 0;
      flex: 1;
      overflow-y: scroll;
      .result_item {
        display: flex;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.03);
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 15px;
        &:nth-last-child(1) {
          margin-bottom: 0px;
        }
        .img {
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }
        .result_info {
          width: 0;
          flex: 1;
          > ul {
            display: flex;
            flex-wrap: wrap;
            > li {
              display: flex;
              padding: 0 20px;
              border-right: 1px solid #aaa;
              margin-bottom: 10px;
              > span {
                font-size: 12px;
                color: #666;
              }
              > p {
                font-size: 13px;
                color: #333;
              }
              &:nth-child(1) {
                padding-left: 0px;
              }
              &:nth-last-child(1) {
                padding-right: 0px;
                border: none;
              }
            }
          }
          .result_content {
            > span {
              font-size: 12px;
              color: #666;
            }
            > p {
              font-size: 13px;
              color: #333;
            }
          }
        }
      }
    }
    .null_data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/views/realTime.vue